"use client";

import React from "react";

export function Gallery10_2() {
  return (
    /* bg-wood-light = tvoje světle šedá */
    <section className="bg-wood-light text-black font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        
        {/* Nadpis sekce - Gelasio */}
        <div className="mb-12 text-center md:mb-18 lg:mb-20">
          <h2 className="text-[32px] font-bold font-serif leading-[1.2] md:text-[48px] lg:text-[56px]">
            Obnovy památek
          </h2>
        </div>

        {/* Masonry layout - přesně 7 fotek (2-3-2) */}
        <div className="gap-4 space-y-4 md:columns-2 lg:columns-3 md:gap-6 md:space-y-6">
          
          {/* FOTO 1 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 15.png" className="w-full object-cover" alt="Obnova 1" />
          </div>

          {/* FOTO 2 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 25.png" className="w-full object-cover" alt="Obnova 2" />
          </div>

          {/* FOTO 3 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 35.png" className="w-full object-cover" alt="Obnova 3" />
          </div>

          {/* FOTO 4 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 45.png" className="w-full object-cover" alt="Obnova 4" />
          </div>

          {/* FOTO 5 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 55.png" className="w-full object-cover" alt="Obnova 5" />
          </div>

          {/* FOTO 6 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 65.png" className="w-full object-cover" alt="Obnova 6" />
          </div>

          {/* FOTO 7 */}
          <div className="break-inside-avoid overflow-hidden rounded-sm bg-white">
            <img src="img/Placeholder Image 75.png" className="w-full object-cover" alt="Obnova 7" />
          </div>

        </div>
      </div>
    </section>
  );
}